(() => {
  const OVERRIDE_ID = 'sc-account-bubble-overrides';
  const DESKTOP_MQ = '(min-width: 1025px)';
  const DIALOG_RIGHT_VAR = '--sc-account-dialog-right';

  const OVERRIDE_CSS = `.button.outline {
  --bubble-fill: var(--sc-orange-500);
  --bubble-hover-text: var(--sc-neutral-0);
  background: var(--sc-neutral-950) !important;
  border: none !important;
  box-shadow: none !important;
  color: var(--sc-neutral-0) !important;
}`;

  const injectStyles = (shadow) => {
    if (shadow.getElementById(OVERRIDE_ID)) return;

    const source = document.querySelector('link[rel="stylesheet"][href*="bubble-button.css"]');
    if (source) {
      const link = source.cloneNode();
      link.removeAttribute('id');
      shadow.appendChild(link);
    }

    const style = document.createElement('style');
    style.id = OVERRIDE_ID;
    style.textContent = OVERRIDE_CSS;
    shadow.appendChild(style);
  };

  const enhance = (shadow) => {
    const container = shadow.querySelector('.account__menu-items');
    if (!container) return;
    if (!container.querySelector('.button.outline:not([data-bubble-enhanced])')) return;

    injectStyles(shadow);
    document.dispatchEvent(new CustomEvent('bubble-button:init', { detail: { root: container } }));
  };

  const updateDialogRightInset = (accountEl) => {
    if (!accountEl) return;

    if (!window.matchMedia(DESKTOP_MQ).matches) {
      accountEl.style.removeProperty(DIALOG_RIGHT_VAR);
      return;
    }

    const columns = document.querySelector('header-component .header__columns');
    if (!columns) return;

    const rightInset = Math.max(0, window.innerWidth - columns.getBoundingClientRect().right);
    accountEl.style.setProperty(DIALOG_RIGHT_VAR, `${rightInset}px`);
  };

  const initDialogPositioning = (accountEl) => {
    let resizeFrame = null;

    const scheduleUpdate = () => {
      if (resizeFrame !== null) return;
      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = null;
        updateDialogRightInset(accountEl);
      });
    };

    accountEl.addEventListener('open', scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate);

    const columns = document.querySelector('header-component .header__columns');
    if (columns) {
      new ResizeObserver(scheduleUpdate).observe(columns);
    }

    scheduleUpdate();
  };

  customElements.whenDefined('shopify-account').then(() => {
    const el = document.querySelector('shopify-account');
    if (!el?.shadowRoot) return;

    const shadow = el.shadowRoot;
    enhance(shadow);
    new MutationObserver(() => enhance(shadow)).observe(shadow, {
      childList: true,
      subtree: true,
    });

    initDialogPositioning(el);
  });
})();
